import { EWorkspaceCountry } from '../types/workspaces';

export interface Country {
    id: string;
    name: string;
    code: string;
}

export const COUNTRIES: Country[] = [
    { id: EWorkspaceCountry.EC, name: 'Ecuador', code: EWorkspaceCountry.EC },
    { id: EWorkspaceCountry.MX, name: 'México', code: EWorkspaceCountry.MX },
    { id: EWorkspaceCountry.DO, name: 'República Dominicana', code: EWorkspaceCountry.DO },
    { id: EWorkspaceCountry.PE, name: 'Perú', code: EWorkspaceCountry.PE },
    { id: EWorkspaceCountry.CO, name: 'Colombia', code: EWorkspaceCountry.CO },
    { id: EWorkspaceCountry.GT, name: 'Guatemala', code: EWorkspaceCountry.GT },
    { id: EWorkspaceCountry.CR, name: 'Costa Rica', code: EWorkspaceCountry.CR },
    { id: EWorkspaceCountry.CL, name: 'Chile', code: EWorkspaceCountry.CL },
    { id: EWorkspaceCountry.AR, name: 'Argentina', code: EWorkspaceCountry.AR },
    { id: EWorkspaceCountry.UY, name: 'Uruguay', code: EWorkspaceCountry.UY },
    { id: EWorkspaceCountry.PA, name: 'Panamá', code: EWorkspaceCountry.PA },
];

const centerByCountry = (country: string) => {
    console.log(country);
    switch (country) {
    case 'México':
        return {
            lng: -99.133209,
            lat: 19.432607,
        };
    case 'República Dominicana':
        return {
            lng: -70.669291,
            lat: 18.466338,
        };
    case 'Colombia':
        return {
            lng: -74.072092,
            lat: 4.60971,
        };
    case 'Argentina':
        return {
            lng: -64.181053,
            lat: -34.603722,
        };
    case 'Chile':
        return {
            lng: -70.669291,
            lat: 18.466338,
        };
    default:
        return {
            lng: -79.8882522301666,
            lat: -2.09757780361609,
        };
    }
};

export {
    centerByCountry,
};
